/*
 * Radiance Veil wishlists (replaces the Growave wishlist).
 *
 *  - [data-rv-wish="<product id>"][data-handle] hearts (product page, next to the quantity box): tap to save to the
 *    first list; a small message offers "Change" (pick lists / start a new list). Tap a filled heart to remove it
 *    from every list.
 *  - Several named lists: create, rename, delete, move items between lists (Wishlists tab of /apps/rv/account).
 *  - Shoppers who aren't signed in: lists stay on this device (localStorage "rvWish:v2").
 *    Signed-in customers: lists live in their account (Worker /apps/rv/wishlist/items, keyed by the customer id
 *    Shopify signs into the app proxy). Lists saved on the device before signing in move into the account.
 *  - #rv-wl (Wishlists tab of My Account) and the side panel opened by the header heart draw the lists with the
 *    store's own product cards (/products/<handle>?view=rvcard).
 *    The remove X and Move show on hover (desktop) or after tapping Edit (phones).
 *  - html.rv-wish-has fills the header heart when something is saved.
 */
(function () {
  // The signed-in copy is kept per customer, so a different account on the same browser never sees it.
  var KEY = 'rvWish:v2', OLD_KEY = 'rvWish:v1', ACTIVE = 'rvWish:active';
  var CACHE = 'rvWish:acct:' + ((window.rvCustomer && window.rvCustomer.id) || '');
  var API = '/apps/rv/wishlist/items';
  var LOGIN = '/customer_authentication/login?return_to=%2Fapps%2Frv%2Faccount%3Ftab%3Dwishlist';
  var DEFAULT_NAME = 'My Wishlist';
  var signedIn = document.documentElement.getAttribute('data-rv-signed-in') === 'true';
  var lists = [];

  // ---------- Storage helpers ----------
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function readJson(kind, key, fallback) {
    try { var v = JSON.parse(store(kind).getItem(key)); return v == null ? fallback : v; } catch (e) { return fallback; }
  }
  function writeJson(kind, key, value) {
    try { if (value == null) store(kind).removeItem(key); else store(kind).setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function newId() { return 'l' + Math.random().toString(36).slice(2, 12); }
  function cleanItems(items) {
    var seen = {};
    return (Array.isArray(items) ? items : []).filter(function (x) {
      if (!x || !/^\d+$/.test(String(x.id)) || !x.handle || seen[x.id]) return false;
      seen[x.id] = true; return true;
    }).map(function (x) { return { id: String(x.id), handle: String(x.handle) }; });
  }
  function cleanLists(raw) {
    var out = (Array.isArray(raw) ? raw : []).filter(function (l) { return l && l.id; }).map(function (l) {
      return { id: String(l.id), name: String(l.name || DEFAULT_NAME).slice(0, 40), items: cleanItems(l.items) };
    });
    return out.length ? out : [{ id: newId(), name: DEFAULT_NAME, items: [] }];
  }
  function readLocal() {
    var v2 = readJson('localStorage', KEY, null);
    if (v2) return cleanLists(v2);
    var v1 = cleanItems(readJson('localStorage', OLD_KEY, []));      // first version: one list on the device
    return cleanLists([{ id: newId(), name: DEFAULT_NAME, items: v1 }]);
  }
  function hasLocalItems() { return readLocal().some(function (l) { return l.items.length; }); }
  function persist() {
    if (signedIn) writeJson('sessionStorage', CACHE, { t: Date.now(), lists: lists });
    else { writeJson('localStorage', KEY, lists); writeJson('localStorage', OLD_KEY, null); }
  }

  // ---------- Queries ----------
  function find(listId) { for (var i = 0; i < lists.length; i++) if (lists[i].id === listId) return lists[i]; return null; }
  function contains(list, id) { return list.items.some(function (x) { return x.id === String(id); }); }
  function isSaved(id) { return lists.some(function (l) { return contains(l, id); }); }
  function totalItems() { return lists.reduce(function (n, l) { return n + l.items.length; }, 0); }

  // Applies a change to the lists in this browser (same rules as the Worker).
  function applyLocal(b) {
    var l;
    if (b.action === 'add') {
      l = find(b.list) || lists[0];
      if (!contains(l, b.id)) l.items.unshift({ id: String(b.id), handle: b.handle });
    } else if (b.action === 'remove') {
      (b.list ? [find(b.list)].filter(Boolean) : lists).forEach(function (x) { x.items = x.items.filter(function (i) { return i.id !== String(b.id); }); });
    } else if (b.action === 'move') {
      var from = find(b.from), to = find(b.to), item = null;
      if (!from || !to) return;
      from.items = from.items.filter(function (i) { if (i.id === String(b.id)) { item = i; return false; } return true; });
      if (item && !contains(to, b.id)) to.items.unshift(item);
    } else if (b.action === 'create') {
      l = { id: b.newId || newId(), name: b.name, items: [] };
      if (b.id) l.items.push({ id: String(b.id), handle: b.handle });
      lists.push(l);
      return l.id;
    } else if (b.action === 'rename') {
      l = find(b.list); if (l) l.name = b.name;
    } else if (b.action === 'delete') {
      lists = lists.filter(function (x) { return x.id !== b.list; });
      if (!lists.length) lists = cleanLists([]);
    }
  }

  function api(method, body) {
    return fetch(API, {
      method: method, credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json' } : {},
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json(); });
  }

  // Changes the lists; resolves with the new list's id for "create". Signed in: shown right away, then saved
  // to the account (and put back if that fails).
  function change(b) {
    var before = JSON.parse(JSON.stringify(lists));
    var localId = applyLocal(b);
    persist(); refresh();
    if (!signedIn) return Promise.resolve(localId);
    var body = { action: b.action, list: b.list, from: b.from, to: b.to, id: b.id, name: b.name };
    return api('POST', body).then(function (r) {
      if (!r || !r.ok) throw new Error('wishlist');
      if (b.action === 'create' && localId && r.created) remapActive(localId, r.created);
      lists = cleanLists(r.lists); persist(); refresh();
      return r.created || null;
    }).catch(function () {
      lists = before; persist(); refresh();
      toast('Something went wrong. Please try again.');
      return null;
    });
  }

  // ---------- Load ----------
  var ready = (function () {
    if (!signedIn) { lists = readLocal(); return Promise.resolve(); }
    if (hasLocalItems()) {
      var local = readLocal();
      return api('POST', { action: 'merge', lists: local.map(function (l) { return { name: l.name, items: l.items.map(function (i) { return i.id; }) }; }) })
        .then(function (r) {
          if (r && r.ok) { writeJson('localStorage', KEY, null); writeJson('localStorage', OLD_KEY, null); lists = cleanLists(r.lists); persist(); }
          else lists = local;
        }).catch(function () { lists = local; });
    }
    var cache = readJson('sessionStorage', CACHE, null);
    if (cache && Date.now() - cache.t < 10 * 60 * 1000) { lists = cleanLists(cache.lists); return Promise.resolve(); }
    return api('GET').then(function (r) {
      if (r && r.signedIn) { lists = cleanLists(r.lists); persist(); }
      else { signedIn = false; lists = readLocal(); }
    }).catch(function () { lists = cleanLists([]); });
  })();

  // ---------- Small UI helpers ----------
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var toastEl = null, toastTimer = null;
  function toast(text, actionLabel, onAction) {
    if (!toastEl) {
      toastEl = el('<div class="rv-wl-toast" role="status" aria-live="polite"><span></span><button type="button"></button></div>');
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent = text;
    var btn = toastEl.querySelector('button');
    btn.hidden = !actionLabel;
    btn.textContent = actionLabel || '';
    btn.onclick = function () { hideToast(); if (onAction) onAction(); };
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5000);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-open'); }

  // Centered pop-up (native <dialog>): "Save to list" (checkboxes + new list) or "Move to".
  function openDialog(title, buildBody) {
    var dlg = el('<dialog class="rv-wl-dialog"><div class="rv-wl-dialog__head"><p class="rv-wl-dialog__title"></p>' +
      '<button type="button" class="rv-wl-dialog__close" aria-label="Close">' + ICON_X + '</button></div><div class="rv-wl-dialog__body"></div></dialog>');
    dlg.querySelector('.rv-wl-dialog__title').textContent = title;
    document.body.appendChild(dlg);
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { dlg.remove(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });   // tap outside
    dlg.querySelector('.rv-wl-dialog__close').addEventListener('click', close);
    buildBody(dlg.querySelector('.rv-wl-dialog__body'), close);
    dlg.showModal();
    return dlg;
  }

  function newListForm(onCreate) {
    var form = el('<form class="rv-wl-new"><input type="text" maxlength="40" placeholder="New list name" aria-label="New list name" required>' +
      '<button type="submit" class="rv-wl__btn rv-wl__btn--solid">Create</button></form>');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = form.querySelector('input').value.replace(/\s+/g, ' ').trim();
      if (name) onCreate(name.slice(0, 40));
    });
    return form;
  }

  function openSavePicker(id, handle) {
    openDialog('Save to list', function (body, close) {
      function draw() {
        body.innerHTML = '';
        var ul = el('<ul class="rv-wl-pick"></ul>');
        lists.forEach(function (l) {
          var li = el('<li><label><input type="checkbox"><span></span><em></em></label></li>');
          li.querySelector('input').checked = contains(l, id);
          li.querySelector('span').textContent = l.name;
          li.querySelector('em').textContent = l.items.length + (l.items.length === 1 ? ' item' : ' items');
          li.querySelector('input').addEventListener('change', function (e) {
            change({ action: e.target.checked ? 'add' : 'remove', list: l.id, id: id, handle: handle }).then(draw);
          });
          ul.appendChild(li);
        });
        body.appendChild(ul);
        body.appendChild(newListForm(function (name) {
          change({ action: 'create', name: name, id: id, handle: handle }).then(draw);
        }));
        body.appendChild(el('<button type="button" class="rv-wl__btn rv-wl-dialog__done">Done</button>'));
        body.querySelector('.rv-wl-dialog__done').addEventListener('click', close);
      }
      draw();
    });
  }

  function openMovePicker(fromId, id) {
    openDialog('Move to', function (body, close) {
      var others = lists.filter(function (l) { return l.id !== fromId; });
      var ul = el('<ul class="rv-wl-pick rv-wl-pick--move"></ul>');
      others.forEach(function (l) {
        var li = el('<li><button type="button"><span></span><em></em></button></li>');
        li.querySelector('span').textContent = l.name;
        li.querySelector('em').textContent = l.items.length + (l.items.length === 1 ? ' item' : ' items');
        li.querySelector('button').addEventListener('click', function () { close(); change({ action: 'move', from: fromId, to: l.id, id: id }); });
        ul.appendChild(li);
      });
      if (others.length) body.appendChild(ul);
      else body.appendChild(el('<p class="rv-wl-dialog__text">Create another list to move this piece into.</p>'));
      body.appendChild(newListForm(function (name) {
        close();
        change({ action: 'create', name: name }).then(function (newListId) {
          if (newListId) change({ action: 'move', from: fromId, to: newListId, id: id });
        });
      }));
    });
  }

  // ---------- Hearts ----------
  function paint() {
    document.querySelectorAll('[data-rv-wish]').forEach(function (btn) {
      var on = isSaved(btn.getAttribute('data-rv-wish'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
    });
    document.documentElement.classList.toggle('rv-wish-has', totalItems() > 0);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-rv-wish]');
    if (!btn) return;
    event.preventDefault();
    var id = btn.getAttribute('data-rv-wish'), handle = btn.getAttribute('data-handle');
    if (!/^\d+$/.test(id) || !handle) return;
    ready.then(function () {
      if (isSaved(id)) {
        change({ action: 'remove', id: id });
        toast('Removed from your wishlist');
      } else {
        var first = lists[0];
        change({ action: 'add', list: first.id, id: id, handle: handle });
        toast('Saved to ' + first.name, 'Change', function () { openSavePicker(id, handle); });
      }
    });
  });

  // ---------- Wishlists page (#rv-wl) ----------
  var roots = [], activeId = readJson('sessionStorage', ACTIVE, null), editing = false, renaming = false, confirmDelete = false, managing = false;
  var cards = {};                                   // handle -> card HTML (fetched once per page)

  function remapActive(oldId, newIdValue) { if (activeId === oldId) setActive(newIdValue); }
  function setActive(id) { activeId = id; writeJson('sessionStorage', ACTIVE, id); }
  function active() { return find(activeId) || lists[0]; }

  function revealImages(box) {
    box.querySelectorAll('.animation--lazy-load').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      if (!img || img.complete) wrap.classList.add('loaded');
      else img.addEventListener('load', function () { wrap.classList.add('loaded'); }, { once: true });
    });
  }
  function loadCard(item) {
    if (cards[item.handle] !== undefined) return Promise.resolve(cards[item.handle]);
    return fetch('/products/' + encodeURIComponent(item.handle) + '?view=rvcard', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { cards[item.handle] = html.indexOf('product-item') === -1 ? '' : html; return cards[item.handle]; })
      .catch(function () { return ''; });
  }

  function refresh() { paint(); roots = roots.filter(function (r) { return r.isConnected; }); roots.forEach(renderPage); }

  function renderPage(root) {
    function again() { renderPage(root); }
    var list = active();
    setActive(list.id);
    root.innerHTML = '';
    root.classList.toggle('is-editing', editing);

    // List picker: one drop-down button (current list + count), so many lists never crowd the page/panel
    function openNewList() {
      openDialog('New list', function (body, close) {
        body.appendChild(newListForm(function (name) {
          close();
          change({ action: 'create', name: name }).then(function (id) { if (id) { setActive(id); again(); } });
        }));
        var input = body.querySelector('input'); setTimeout(function () { input.focus(); }, 50);
      });
    }
    var picker = el('<div class="rv-wl__picker"><button type="button" class="rv-wl__picker-btn" aria-haspopup="listbox" aria-expanded="false">' +
      '<span class="rv-wl__picker-name"></span><em></em><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 4.5 6 8l3.5-3.5"/></svg></button>' +
      '<div class="rv-wl__picker-menu" role="listbox" aria-label="Your lists" hidden></div></div>');
    var pbtn = picker.querySelector('.rv-wl__picker-btn'), pmenu = picker.querySelector('.rv-wl__picker-menu');
    pbtn.querySelector('.rv-wl__picker-name').textContent = list.name;
    pbtn.querySelector('em').textContent = list.items.length;
    lists.forEach(function (l) {
      var o = el('<button type="button" role="option" class="rv-wl__picker-opt"><span></span><em></em></button>');
      o.querySelector('span').textContent = l.name;
      o.querySelector('em').textContent = l.items.length;
      o.setAttribute('aria-selected', l.id === list.id ? 'true' : 'false');
      o.addEventListener('click', function () { setActive(l.id); editing = renaming = confirmDelete = managing = false; again(); });
      pmenu.appendChild(o);
    });
    var addOpt = el('<button type="button" class="rv-wl__picker-opt rv-wl__picker-opt--new">+ New list</button>');
    addOpt.addEventListener('click', function () { pmenu.hidden = true; pbtn.setAttribute('aria-expanded', 'false'); openNewList(); });
    pmenu.appendChild(addOpt);
    pbtn.addEventListener('click', function () {
      var open = pmenu.hidden;
      pmenu.hidden = !open;
      pbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Close when tapping anywhere else (listener removed when this view is redrawn)
    function outside(e) { if (!picker.isConnected) { document.removeEventListener('click', outside, true); return; } if (!picker.contains(e.target)) { pmenu.hidden = true; pbtn.setAttribute('aria-expanded', 'false'); } }
    document.addEventListener('click', outside, true);
    root.appendChild(picker);

    // Active list header: name, count, Rename / Delete / Edit
    var head = el('<div class="rv-wl__head"></div>');
    if (renaming) {
      var rf = el('<form class="rv-wl-new rv-wl-rename"><input type="text" maxlength="40" aria-label="List name" required>' +
        '<button type="submit" class="rv-wl__btn rv-wl__btn--solid">Save</button><button type="button" class="rv-wl__link">Cancel</button></form>');
      rf.querySelector('input').value = list.name;
      rf.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = rf.querySelector('input').value.replace(/\s+/g, ' ').trim().slice(0, 40);
        renaming = false;
        if (name && name !== list.name) change({ action: 'rename', list: list.id, name: name }); else again();
      });
      rf.querySelector('.rv-wl__link').addEventListener('click', function () { renaming = false; again(); });
      head.appendChild(rf);
      setTimeout(function () { rf.querySelector('input').select(); }, 30);
    } else if (confirmDelete) {
      var cd = el('<div class="rv-wl__confirm"><p></p><button type="button" class="rv-wl__link rv-wl__keep">Keep list</button><button type="button" class="rv-wl__btn rv-wl__btn--danger">Yes, delete</button></div>');
      cd.querySelector('p').textContent = 'Delete "' + list.name + '"?' + (list.items.length ? ' The ' + list.items.length + ' saved ' + (list.items.length === 1 ? 'item' : 'items') + ' in it will be removed too.' : '');
      cd.querySelector('.rv-wl__btn--danger').addEventListener('click', function () { confirmDelete = false; setActive(null); change({ action: 'delete', list: list.id }); });
      cd.querySelector('.rv-wl__keep').addEventListener('click', function () { confirmDelete = false; again(); });
      head.appendChild(cd);
    } else {
      var title = el('<div class="rv-wl__title"><p class="rv-wl__name"></p><p class="rv-wl__count"></p></div>');
      title.querySelector('.rv-wl__name').textContent = list.name;
      title.querySelector('.rv-wl__count').textContent = list.items.length + (list.items.length === 1 ? ' item' : ' items');
      head.appendChild(title);
      // One "Manage list" button opens a small menu (Edit items / Rename / Delete), so a stray tap on a phone
      // can't rename or delete anything. While editing, the button becomes a clear "Done".
      var actions;
      if (editing) {
        actions = el('<div class="rv-wl__actions"><button type="button" class="rv-wl__btn rv-wl__btn--solid rv-wl__done">Done</button></div>');
        actions.querySelector('button').addEventListener('click', function () { editing = false; again(); });
      } else {
        actions = el('<div class="rv-wl__actions rv-wl__manage"><button type="button" class="rv-wl__manage-btn" aria-haspopup="menu" aria-expanded="' + managing + '">Manage list' +
          '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 4.5 6 8l3.5-3.5"/></svg></button>' +
          '<div class="rv-wl__manage-menu" role="menu"' + (managing ? '' : ' hidden') + '>' +
          (list.items.length ? '<button type="button" role="menuitem" data-a="edit">Move or remove items</button>' : '') +
          '<button type="button" role="menuitem" data-a="rename">Rename list</button>' +
          '<button type="button" role="menuitem" data-a="delete" class="rv-wl__manage-del">Delete list</button></div></div>');
        actions.querySelector('.rv-wl__manage-btn').addEventListener('click', function () { managing = !managing; again(); });
        actions.querySelector('.rv-wl__manage-menu').addEventListener('click', function (e) {
          var a = e.target.closest('[data-a]'); if (!a) return;
          managing = false;
          if (a.dataset.a === 'rename') renaming = true;
          if (a.dataset.a === 'delete') confirmDelete = true;
          if (a.dataset.a === 'edit') editing = true;
          again();
        });
        var mroot = actions;
        function mOutside(e) { if (!mroot.isConnected) { document.removeEventListener('click', mOutside, true); return; } if (managing && !mroot.contains(e.target)) { managing = false; mroot.querySelector('.rv-wl__manage-menu').hidden = true; mroot.querySelector('.rv-wl__manage-btn').setAttribute('aria-expanded', 'false'); } }
        document.addEventListener('click', mOutside, true);
      }
      head.appendChild(actions);
    }
    root.appendChild(head);

    if (!signedIn) root.appendChild(el('<p class="rv-wl__note">Saved on this device. <a href="' + LOGIN + '">Sign in</a> to keep your wishlists on every device.</p>'));

    if (!list.items.length) {
      root.appendChild(el('<div class="rv-wl__empty"><p class="rv-wl__empty-title">Nothing saved here yet</p>' +
        '<p class="rv-wl__empty-text">Tap the heart on any piece you love to save it.</p><a class="rv-wl__btn" href="/collections/all">Shop now</a></div>'));
      return;
    }

    var grid = el('<div class="rv-wl__grid"></div>');
    root.appendChild(grid);
    list.items.forEach(function (item) {
      var card = el('<div class="rv-wl__card"></div>');
      grid.appendChild(card);
      loadCard(item).then(function (html) {
        if (!html) { card.remove(); return; }
        card.innerHTML = html;
        // Move / Remove sit under the product (shown by "Edit list"), never on the photo, so they can't cover badges.
        var tools = el('<div class="rv-wl__tools">' +
          '<button type="button" class="rv-wl__move">Move</button><span aria-hidden="true">·</span>' +
          '<button type="button" class="rv-wl__remove">Remove</button></div>');
        tools.querySelector('.rv-wl__remove').addEventListener('click', function (e) {
          e.preventDefault();
          change({ action: 'remove', list: list.id, id: item.id });
        });
        tools.querySelector('.rv-wl__move').addEventListener('click', function (e) {
          e.preventDefault();
          openMovePicker(list.id, item.id);
        });
        card.appendChild(tools);
        revealImages(card);
      });
    });
  }

  // ---------- Side panel (header heart) ----------
  function openDrawer() {
    var dlg = el('<dialog class="rv-wl-drawer" aria-label="Wishlist"><div class="rv-wl-drawer__head"><p class="rv-wl-drawer__title">Wishlist</p>' +
      '<button type="button" class="rv-wl-dialog__close" aria-label="Close">' + ICON_X + '</button></div>' +
      '<div class="rv-wl-drawer__body"><div class="rv-wl-root"></div></div>' +
      '<div class="rv-wl-drawer__foot"><a class="rv-wl__btn" href="/apps/rv/account?tab=wishlist">Go to My Account</a></div></dialog>');
    document.body.appendChild(dlg);
    var body = dlg.querySelector('.rv-wl-root');
    function close() { dlg.classList.remove('is-open'); setTimeout(function () { if (dlg.open) dlg.close(); }, 250); }
    dlg.addEventListener('close', function () { roots = roots.filter(function (r) { return r !== body; }); dlg.remove(); document.documentElement.classList.remove('rv-wl-drawer-open'); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.querySelector('.rv-wl-dialog__close').addEventListener('click', close);
    roots.push(body);
    renderPage(body);
    dlg.showModal();
    document.documentElement.classList.add('rv-wl-drawer-open');
    requestAnimationFrame(function () { dlg.classList.add('is-open'); });
  }
  document.addEventListener('click', function (e) {
    var heart = e.target.closest && e.target.closest('.header__icon-touch--wishlist');
    if (!heart || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    e.stopPropagation();                         // before the theme's page-transition link handler
    var menu = heart.closest('.drawer-menu');
    if (menu && menu.classList.contains('active')) { var o = menu.querySelector('[data-overlay]'); if (o) o.click(); }
    // On My Account the full Wishlists tab is right there, so the heart switches to it instead of opening a second, smaller copy.
    var acctTab = document.querySelector('.rv-acct [data-rv-tab="wishlist"]');
    if (acctTab) { acctTab.click(); acctTab.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    ready.then(openDrawer);
  }, true);

  // Quick add / quick view on wishlist cards. The theme only wires product cards that exist when a page loads, so the
  // cards drawn here (side panel + My Account) are handled the same way the theme does it (theme.min.js exposes
  // window.rvEmit, the theme's event bus). The side panel closes first so the cart or quick view isn't hidden behind it.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rv-wl__card [data-quick-shop-trigger]');
    if (!btn || !window.rvEmit) return;
    e.preventDefault();
    e.stopPropagation();
    var drawer = btn.closest('dialog');
    if (btn.getAttribute('data-quick-shop-trigger') === 'quick-view') {
      if (drawer && drawer.open) { drawer.classList.remove('is-open'); drawer.close(); }
      if (btn.dataset.productUrl) window.rvEmit('quick-view:open', null, { productUrl: btn.dataset.productUrl });
      return;
    }
    var id = btn.dataset.productId;
    if (!id) return;
    btn.classList.add('loading');
    fetch('/cart/add.js', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: Number(btn.getAttribute('data-quantity-minimum')) || 1 }] }) })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); }).then(function (res) {
      btn.classList.remove('loading');
      // In the side panel: stay open, mark the button and show a small "Added to bag · View bag" note.
      if (drawer && drawer.open) {
        window.rvEmit('quick-cart:updated');
        var was = btn.textContent;
        btn.classList.add('rv-qa__size--added'); btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('rv-qa__size--added'); btn.textContent = was; }, 1500);
        var note = drawer.querySelector('.rv-wl-added');
        if (!note) {
          note = el('<div class="rv-wl-added" role="status"><span></span><button type="button">View bag</button></div>');
          note.querySelector('button').addEventListener('click', function () {
            drawer.classList.remove('is-open'); drawer.close();
            setTimeout(function () { window.rvEmit('quick-cart:open'); }, 200);
          });
          drawer.appendChild(note);
        }
        var name = (btn.getAttribute('aria-label') || '').replace(/^Add /, '').replace(/, size (.*), to bag$/, ' ($1)').replace(/ to bag$/, '');
        note.querySelector('span').textContent = 'Added to bag: ' + name;
        note.classList.add('is-shown');
        clearTimeout(note._t); note._t = setTimeout(function () { note.classList.remove('is-shown'); }, 4000);
        return;
      }
      if (document.querySelector('.purchase-confirmation-popup') && res && res.items) {
        window.rvEmit('confirmation-popup:open', null, { product: res.items[0] });
      } else {
        window.rvEmit('quick-cart:updated');
        setTimeout(function () { window.rvEmit('quick-cart:open'); }, 300);
      }
    }, function () { btn.classList.remove('loading'); window.rvEmit('quick-cart:open'); });
  }, true);

  // Cards added later (filters, infinite scroll, recommendations) get the right filled/empty heart too.
  var paintQueued = false;
  new MutationObserver(function (records) {
    if (paintQueued) return;
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-rv-wish]') || n.querySelector('[data-rv-wish]'))) {
          paintQueued = true;
          requestAnimationFrame(function () { paintQueued = false; ready.then(paint); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  function init() {
    paint();
    ready.then(function () {
      paint();
      var pageRoot = document.getElementById('rv-wl');
      if (pageRoot) { pageRoot.classList.add('rv-wl-root'); roots.push(pageRoot); renderPage(pageRoot); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.RVWishlist = { ready: ready, isSaved: isSaved, lists: function () { return JSON.parse(JSON.stringify(lists)); } };
})();
